<script>
export default {
  props: {
    component: Object,
    handler: Object,
  },
  mounted() {
    if (this.handler && !this.component.read)
      this.handler.action(this.component, "read", []);

    this.$emit('mounted', this.$el);
  },
};
</script>

<template>
  <div
    class="message"
    :class="{ from_moderator: component.data.from_moderator }"
  >
    <div class="author">{{ component.data.author }}</div>
    <div class="text">{{ component.data.text }}</div>
    <div class="date">
      {{ (component.data.date * 1000) | angularFilter("HH:mm", "date") }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.message {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: Lato;
  font-size: 14px;
  padding: 8px;

  &.from_moderator {
    .author {
      color: #20a0a0;
    }
  }

  .author {
    font-size: 12px;
    font-weight: 700;
  }

  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .date {
    color: #bbbbbb;
    font-weight: 400;
    font-size: 12px;
  }
}
</style>